import React, { useRef } from "react";
import { Avatar } from "@mui/material";
import { UserIcon, KeyIcon, ArrowRightOnRectangleIcon, ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { setActivePage } from "../../features/navigation/navigationSlice";
import { useDispatch, useSelector } from "react-redux";
import DEFAULT_ROUTES from "../../constants/routes";
import handleLogout from "../handleLogout";
import GenericActionMenu from "../menu/GenericActionMenu";
import { stringToColor, getInitial } from "../../utils/string";
import styles from '../../styles/navProfile/ProfileMenu.module.scss';

const ProfileMenu = ({ user, isMenuOpen, toggleMenu }) => {
  const permissions = useSelector((state) => state.auth?.user?.permissions) ?? [];
  const has_admin_page_access = Array.isArray(permissions) && permissions.includes("access_admin_page");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const menuRef = useRef();

  const handleProfileClick = () => {
    dispatch(setActivePage("Profile"));
    navigate(`${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROFILE}`);
  };

  const handleProfileAreaClick = (event) => {
    if (menuRef.current) {
      menuRef.current.triggerClick(event);
    }
  };

  const userMenuItems = [
    { 
      name: "Your Profile", 
      icon: <UserIcon className="icon" />,
      action: handleProfileClick 
    },
    { 
      name: "Change Password", 
      icon: <KeyIcon className="icon" />,
      action: () => navigate("/changePassword")
    },
    { 
      name: "Sign out", 
      icon: <ArrowRightOnRectangleIcon className="icon" />,
      action: () => handleLogout(navigate, dispatch)
    },
  ];

  return (
    <div className={styles['profile-menu-container']}>
      <div className={styles['profile-info']} onClick={handleProfileAreaClick}>
        <Avatar
          sx={{
            bgcolor: user ? stringToColor(user?.username) : "green",
            width: {xl: 29, md: 24},
            height: {xl: 29, md: 24},
            fontSize: {xl: "14px", md: "12px"}, 
          }}
          className={styles['profile-avatar']}
        >
          {getInitial(user?.username)}
        </Avatar>
        <span className={styles['profile-username']}>{user?.username}</span>
      </div>
      
      <GenericActionMenu 
        ref={menuRef}
        menuItems={userMenuItems}
        position="right"
        icon={isMenuOpen ? ChevronUpIcon : ChevronDownIcon}
        iconClassName={styles['profile-chevron']}
        onToggle={toggleMenu}
      />
    </div>
  );
};

export default ProfileMenu;
